import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Container } from '../../../../components/PriceOverviewCard/components/Products/components/Container.js';
import { DEFAULT_LOCALE } from '../../../../components/PriceOverviewCard/models.js';
import { Flex, LabelMediumSemiBold, LabelXSmall } from '../../../../primitives/index.js';
import { priceFormatter, qaId } from '../../../../utils/index.js';
import { PRICE_OVERVIEW_QA_ID } from '../../../../utils/qaId.js';
export const Products = ({
  products,
  locale = DEFAULT_LOCALE
}) => {
  return _jsx(Container, {
    children: products?.map(({
      type,
      title,
      price,
      displayPrice
    }) => _jsxs(Flex, {
      direction: "row",
      justifyContent: "space-between",
      "data-testid": qaId(PRICE_OVERVIEW_QA_ID, `${type}`),
      children: [_jsx("div", {
        children: title
      }), _jsx(Flex, {
        gap: "global/small",
        alignItems: "end",
        children: displayPrice.currency !== price.currency && displayPrice.value !== 0 ? _jsxs(_Fragment, {
          children: [_jsx(LabelMediumSemiBold, {
            children: priceFormatter(locale, displayPrice.currency).format(displayPrice.value)
          }), _jsx(LabelXSmall, {
            color: "contentSecondary",
            children: priceFormatter(DEFAULT_LOCALE, price.currency).format(price.value)
          })]
        }) : _jsx("div", {
          children: priceFormatter(locale, displayPrice.currency).format(displayPrice.value)
        })
      })]
    }, title))
  });
};